import styled from 'styled-components';
import { CaptionBoldLUppercase, LabelRegularBoldM } from '../../../styles/globals';
import { IThemeProvider, ITheme } from '../../../styles/theme';

interface IReportPredictiveStatesTileHeaderCont {
  theme: ITheme;
  first?: boolean;
}
export const ReportPredictiveStatesTileHeaderCont = styled.div<IReportPredictiveStatesTileHeaderCont>`
  position: relative;
  display: flex;
  box-sizing: border-box;
  ${({ theme }: IReportPredictiveStatesTileHeaderCont) => `
    padding: ${theme.layout.spacing.decy} 0 ${theme.layout.spacing.centy} ${theme.layout.spacing.giga};
  `}
`;

export const SortHeaderCont = styled.div`
  position: relative;
  display: flex;
  height: 24px;
  flex: 2.35;
  align-items: center;
`;

export const PredictiveColumnTitle = styled(LabelRegularBoldM)`
  display: inline-block;
  text-transform: uppercase;

  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;

interface IAccArrowCont {
  active?: boolean;
  inActive?: boolean;
  theme: ITheme;
}

export const CatHeadArrowCont = styled.div<IAccArrowCont>`
  cursor: pointer;
  svg {
    margin: 0 0 0 7px;
    width: 10px;
    height: 5px;
    position: relative;
    top: -2px;
    ${({ active, inActive }) => `
    ${
  inActive
    ? `
             opacity: 0.4;
        `
    : ''
}
    ${
  active
    ? `
     transform: rotate(180deg);
     top: -2px;
    `
    : ''
}
  `};
  }
`;

export const PredictiveStatesTitle = styled(CaptionBoldLUppercase)`
  display: flex;
  height: 24px;
  flex: 1;
  align-items: center;

  ${({ theme }: IThemeProvider) => `
    color:  ${theme.colors.neutral.primary[80]};
     svg {
      margin: 0 0 0 ${theme.layout.spacing.mikro};
      width: 13.33px;
      height: 13.33px;
     }
  `}
`;
